export default "__VITE_ASSET__BwhYJLBf__"